import { useEffect, useState } from 'react';
import {
  getStartingSizePosition,
  resizeDesktopMap,
} from '../../components/organisms/MapNavigation/updateMap/updateDesktopMap';

const useDesktopMap = ({ ref, isMobile, windowHeight, windowWidth }) => {
  const [mapSizePosition, setMapSizePosition] = useState();

  useEffect(() => {
    if (!isMobile) {
      setMapSizePosition(getStartingSizePosition(windowWidth, windowHeight));
    }
  }, [isMobile, windowHeight, windowWidth]);

  useEffect(() => {
    if (mapSizePosition) {
      resizeDesktopMap(ref, mapSizePosition);
    }
  }, [mapSizePosition]);

  // image position, svg drawing position, parts of map will be shown
  return mapSizePosition ?? {};
};

export default useDesktopMap;
